import { Satellite, Mic2, Zap, Smartphone, Shield, Globe, Clock, BarChart3 } from 'lucide-react';

const features = [
  {
    icon: Satellite,
    title: 'Uydu Görüntü Teknolojisi',
    description: 'Dünya üzerindeki herhangi bir konumu 4K netliğinde uydu görüntüleriyle videoya dönüştürün.',
  },
  {
    icon: Mic2,
    title: 'Yapay Zeka Seslendirme',
    description: 'Videolarınıza doğal dillerde ve profesyonel tonda otomatik seslendirme ekleyin.',
  },
  {
    icon: Zap,
    title: 'Hızlı Render',
    description: 'Bulut tabanlı sistemimiz sayesinde videonuz dakikalar içinde hazır hale gelir.',
  },
  {
    icon: Smartphone,
    title: 'Sosyal Medya Uyumlu',
    description: 'Instagram, TikTok ve YouTube Shorts için dikey ve yatay format seçenekleri.',
  },
  {
    icon: Shield,
    title: 'Güvenli ve Gizli',
    description: 'Verileriniz şifrelenerek saklanır. Hiçbir mülk bilgisi üçüncü taraflarla paylaşılmaz.',
  },
  {
    icon: Globe,
    title: 'Global Kapsama',
    description: 'Dünya genelindeki tüm lokasyonlar için uydu görüntüsü erişimi.',
  },
  {
    icon: Clock,
    title: '7/24 Erişim',
    description: 'Gece gündüz demeden platforma erişin ve istediğiniz zaman video üretin.',
  },
  {
    icon: BarChart3,
    title: 'Detaylı Analiz',
    description: 'Çevre analizi, POI keşfi ve kapsamlı raporlama özellikleri.',
  },
];

export default function Features() {
  return (
    <section id="features" className="section-padding">
      <div className="container-custom">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full 
                          bg-primary/10 text-primary text-sm font-semibold mb-4">
            Neden Maplio?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-slate-900 dark:text-white">
            Emlak Pazarlamasında <span className="gradient-text">Yeni Nesil</span> Teknoloji
          </h2>
          <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto text-lg">
            Geleneksel yöntemlere göre %90 daha hızlı ve maliyet etkin çözümler.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="card p-6 hover:shadow-lg transition-all duration-300 
                         group hover:-translate-y-1"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 text-primary 
                              flex items-center justify-center mb-5 
                              group-hover:bg-primary group-hover:text-white 
                              transition-colors duration-300">
                <feature.icon className="w-7 h-7" />
              </div>
              <h3 className="text-lg font-bold mb-2 text-slate-900 dark:text-white 
                             group-hover:text-primary transition-colors">
                {feature.title}
              </h3>
              <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
